/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const liveSearchProductsError = {
    /**
     * Handle errors during product fetch
     *
     * @param {Error} error - The error object.
     */
    handleProductFetchError(error) {
        console.error("Error fetching or mapping products:", error);

        // Reset products and facets
        this.resetFacets();
        this.resetProducts();

        // Error message to user
        typeof window.dispatchMessages !== "undefined" && window.dispatchMessages(
            [{
                type: "error",
                text: this.errorMessages.productFetchError,
            }], 5000
        );
    }
}

export default liveSearchProductsError;
